import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, CircularProgress, Grid, Typography, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CheckBox from "../icons/CheckBox.svg";
import UnCheckedBox from "../icons/UnCheckedBox.svg";

interface TermsDialogProps {
  open: boolean;
  handleClose?: () => void
  handleConfirm: (event: React.MouseEvent<HTMLButtonElement>) => void
  title: string;
  text: string;
  scroll: boolean;
  buttonText: string;
  accpetText?: string;
  height?: string;
}

export const useStyle = makeStyles(() => ({
  text: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: 400,
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
    overflow: 'auto !important',
  },
  accpetText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: 400,
    fontSize: '16px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
    marginLeft: "10px !important",
    cursor: "pointer !important",
  },
  buttontext: {
    fontFamily: 'sans-serif !important',
    fontStyle: 'normal !important',
    fontWeight: 400,
    textTransform: 'capitalize',
    fontSize: '16px !important',
    lineHeight: '22px !important',
  },
}));

function TermsDialog(props: TermsDialogProps) {
  const classes = useStyle();
  const matchesMobile = useMediaQuery("(max-width:600px)");

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  const [accepted, setAccepted] = React.useState(false);

  return (
    <div>
      <Dialog
        open={props.open}
        scroll={props.scroll ? "paper" : "body"}
        maxWidth="md"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        PaperProps={{ style: { pointerEvents: "auto", borderRadius: "24px" } }}
        sx={{ height: props.height ?? '60%', pt: matchesMobile ? 6: 24 }}
        onClose={() => props.handleClose && props.handleClose()}
      >
        <DialogTitle id="scroll-dialog-title" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '700' }}>{props.title}</DialogTitle>
        <DialogContent
          sx={{
            mx: 2,
            px: 1,
            "&::-webkit-scrollbar": {
              width: 7,
            },
            "&::-webkit-scrollbar-track": {
              boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
              borderRadius: '24px',
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "darkgrey",
              borderRadius: '24px',
            },
          }}
        >
          <Box
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            className={classes.text}
          >
            {props.text ? 
              <div dangerouslySetInnerHTML={{ __html: props.text.replace(/<\/?html>|<\/?body>/g, '')  }} />
            
            : (
              <Grid item sx={{display:'flex', justifyContent:"center"}} xs={12}>
                <CircularProgress size={26} />
              </Grid>
            )}
          </Box>
        </DialogContent>
        {!!props.text && !!props.accpetText && (
          <Box sx={{ display: 'flex', alignItems: 'center', padding: "20px 20px 0" }}>
            <img src={accepted ? CheckBox : UnCheckedBox} style={{ width: "11px", height: "11px", cursor: "pointer" }} alt='Checkmark' onClick={() => setAccepted(!accepted)} />
            <Typography className={classes.accpetText} variant="caption" onClick={() => setAccepted(!accepted)}>
              {props.accpetText}
            </Typography>
          </Box>
        )}
        <DialogActions sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 2 }}>
          <Button 
            variant="contained"
            onClick={props.handleConfirm}
            sx={{ borderRadius: '20px', fontSize: 'small' }} size="large"
            disabled={!!props.accpetText && !accepted}
          >
            <Typography className={classes.buttontext} variant="caption">
              {props.buttonText}
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </div>);
}

TermsDialog.propTypes = {};

export default TermsDialog;
